/**
 * Read shape returned by `GET api/employee/odata-query` (see `EmployeeQueryResultDto`).
 * Distinct from {@link EmployeeDetailsDto} (the register write body): every field is
 * optional because the packet `User` columns are nullable — the read endpoint surfaces
 * nulls as null instead of fabricating a DOB/HRRef.
 */
export interface EmployeeQueryResult {
  Ssn?: string;
  HRRef?: number;
  FirstName?: string;
  LastName?: string;
  MiddleName?: string;
  NameSuffix?: string;
  NickName?: string;
  DateOfBirth?: Date;
  CellPhone?: string;
  Email?: string;
  IdCardType?: string;
  IdCardNumber?: string;
  IdCardExpiration?: Date;
  SecurityUserId?: string;
}
